var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tabbar" }, [
    _c(
      "a",
      {
        staticClass: "item",
        class: { active: _vm.tab === 1 },
        on: {
          click: function($event) {
            _vm.active(1)
          }
        }
      },
      [
        _c("img", {
          staticClass: "icon",
          attrs: {
            src: "//img1.jianyewy.com/881f0984ac67e76d62543052f2e3088d.png"
          }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "label" }, [_vm._v("Home")])
      ]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "item",
        class: { active: _vm.tab === 2 },
        on: {
          click: function($event) {
            _vm.active(2)
          }
        }
      },
      [
        _c("img", {
          staticClass: "icon",
          attrs: {
            src: "//img1.jianyewy.com/881f0984ac67e76d62543052f2e3088d.png"
          }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "label" }, [_vm._v("Category")])
      ]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "item",
        class: { active: _vm.tab === 3 },
        on: {
          click: function($event) {
            _vm.active(3)
          }
        }
      },
      [
        _c("img", {
          staticClass: "icon",
          attrs: {
            src: "//img1.jianyewy.com/881f0984ac67e76d62543052f2e3088d.png"
          }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "label" }, [_vm._v("Cart")])
      ]
    ),
    _vm._v(" "),
    _c(
      "a",
      {
        staticClass: "item",
        class: { active: _vm.tab === 4 },
        on: {
          click: function($event) {
            _vm.active(4)
          }
        }
      },
      [
        _c("img", {
          staticClass: "icon",
          attrs: {
            src: "//img1.jianyewy.com/881f0984ac67e76d62543052f2e3088d.png"
          }
        }),
        _vm._v(" "),
        _c("span", { staticClass: "label" }, [_vm._v("Usercenter")])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }